import styled from 'styled-components'
import { ButtonLink } from '@chegg/fanta'
import { Large } from '@chegg-wt/core/theme/fanta/button'
import { Heading1, Heading2, Body } from '@chegg-wt/core/theme/sunkist/typography'
import { breakpoints, font, colors, spacing } from '@chegg-ui/theme'
import CoreSaleBadge from './SaleBadge/SaleBadge'

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  height: 50px;
`
export const Button = styled(ButtonLink)`
  ${Large};
  width: 457px;
  padding: 0;
  text-align: center;
  cursor: pointer;
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  background-color: ${({ theme }) => theme.Colors.primaryColor};
  @media (max-width: ${breakpoints.md.max}) {
    width: 256px;
  }
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`

export const BoldHeader = styled.div`
  ${Heading1};
  font-weight: 700;
  text-align: center;
`
export const BadgeText = styled.div`
  ${Heading2};
  color: ${colors.white};
  font-weight: 700;
  text-align: center;
`

export const BodyText = styled.div`
  ${Body}
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  padding: 20px auto;
`

export const AlignCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`
export const SaleBadge = styled(CoreSaleBadge)`
  margin-top: ${spacing.px4};
  font-size: ${font.size.px18};
  margin-right: ${spacing.px32};
  position: relative;

  @media (max-width: ${breakpoints.lg.min}) {
    margin-right: ${spacing.px8};
  }
`

export const ConfettiWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
`

export const BadgeWrapperDesktop = styled.div`
  width: 140px;
  height: 140px;
  position: absolute;
  top: -70px;
  left: -70px;

  @media (max-width: ${breakpoints.sm.max}) {
    display: none;
  }
`

export const BadgeWrapperMobile = styled.div`
  @media (min-width: ${breakpoints.sm.max}) {
    display: none;
  }
`
